import { createFileRoute } from '@tanstack/react-router'

import { TwoFactorSetupPage } from '@/pages/auth/TwoFactorSetupPage'

export const Route = createFileRoute('/2fa-setup')({
  component: TwoFactorSetupPage,
})
